import React from 'react';
import { makeStyles } from 'tss-react/mui';

import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useConfirm } from './ConfirmationDialog';
import { useAppSelector } from 'hooks';

const useStyles = makeStyles()(({ spacing, transitions }) => ({
    header: {
        display: 'grid',
        gridTemplateColumns: '1fr auto',
    },
    closeBtn: {
        width: 48,
        height: 48,
        margin: spacing(1),
    },
    section: {
        margin: `${spacing(1)} ${spacing(0)}`,
    },
    toggle: {
        padding: `${spacing(0.5)} ${spacing(2)}`,
    },
    transitionWidth: {
        minWidth: 232,
        transition: `${transitions.create('width', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.standard,
        })}`,
    },
}));

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: (retainExistingItems: boolean) => void;
}

/**
 * Is a Dialogue box used to add a new Plan.
 */
const NewPlanDialog: React.FunctionComponent<Props> = ({
    open,
    onClose,
    onConfirm,
}) => {
    const { classes } = useStyles();

    const { guide } = useAppSelector((s) => s);
    const withConfirm = useConfirm();

    const handleConfirm = (confirmed: boolean) => {
        if (!confirmed) {
            withConfirm(`Are you sure that you want to start a new plan without retaining the ${
                guide.selectedPlanType === 'bfrmp'
                    ? 'Pilot Areas'
                    : 'FAFT'
            }
            items in your new plan.
            This action is permanent and is NOT reversible.`).then(() => {
                onConfirm(confirmed);
            });
        } else {
            onConfirm(confirmed);
        }

        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <div className={classes.header}>
                <DialogTitle>Add a New Plan</DialogTitle>
                <IconButton className={classes.closeBtn} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </div>

            <DialogContent>
                <DialogContentText>
                    {guide.selectedPlanType === 'bfrmp'
                        ? 'Do you wish to retain existing Pilot Areas in your new plan?'
                        : 'Do you wish to retain existing FAFT items in the New Plan?'}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleConfirm(true)} color="primary">
                    Yes
                </Button>
                <Button onClick={() => handleConfirm(false)} color="primary">
                    No
                </Button>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

NewPlanDialog.displayName = 'NewPlanDialog';
export default NewPlanDialog;
